module.exports = __webpack_public_path__ + "static/media/featured_experience_image@2x.8c7d2a55.png";